// Purpose: client for the /api/graph/* endpoints. Used by dropbox creation
// forms to populate SharePoint site + shared-drive dropdowns.

import { api } from './client.ts';

export interface SiteSummary {
  id: string;
  displayName: string;
  webUrl: string;
}

export interface DriveSummary {
  id: string;
  name: string;
  driveType: 'personal' | 'business' | 'documentLibrary';
  siteId?: string;
}

export async function listSites(): Promise<SiteSummary[]> {
  const res = await api.get<{ sites: SiteSummary[] }>('/graph/sites');
  return res.data.sites;
}

export async function listDrives(): Promise<DriveSummary[]> {
  const res = await api.get<{ drives: DriveSummary[] }>('/graph/drives');
  return res.data.drives;
}
